import { useEffect } from "react";

const API_URL = process.env.REACT_APP_API_URL || "";

function VisitorTracker() {
    useEffect(() => {
        try {
            const path = window.location.pathname;
            if (path.startsWith("/admin") || path.startsWith("/api")) return;

            fetch(API_URL + "/api/track-visit", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    path: path,
                    referrer: document.referrer || "",
                    userAgent: navigator.userAgent || ""
                }),
                keepalive: true
            }).catch(() => {});
        } catch (e) {}
    }, []);

    return null;
}

export default VisitorTracker;
